
import axios from 'axios'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Toast from 'vux/src/components/toast/index.vue'

import { Debounce } from '../utils'
import Bus from '../bus'
import Disclaimer from './Disclaimer'
export default {
name:'AddSubmit',
directives: {
TransferDom
},
components:{
TransferDom, XDialog, Group, XInput, XTextarea, XButton, Flexbox, FlexboxItem,Toast,
Disclaimer
},
props:['showmodal','infoPlaceHolder','info','type'],
data(){
return {
name:'',
nameIcon:'',
location:'',
locationIcon:'',
phone:'',
phoneIcon:'',
materialDes:'',
isToast: false,
toastMsg: '提交成功',
toastType: 'success',
}
},
watch:{
showmodal(v){

},
},
methods:{
setIconType (v, icon) {
if (v == "") {
this[icon] = "error"
} else {
this[icon] = "success"
}
},
submit: Debounce(function () {

const _this = this;
if (this.name == "") {
this.nameIcon = "error"
return
}
if (this.location == "") {
this.locationIcon = "error"
return
}
if (this.phone == "") {
this.phoneIcon = "error"
return
}
if (this.materialDes == "") {
this.isToast = true
this.toastMsg = `${this.info}必填`
this.toastType = "text"
return
}

axios.post('/yuncai-yop/contribute/save', {
name: this.name,
phone: this.phone,
location: this.location,
materialDes: this.materialDes,
type:this.type,
systemId:0
}).then(function (res) {
_this.isToast = true
_this.toastMsg = "提交成功,物资信息需经平台审核通过后方可公布出来"
_this.toastType = "success"
console.log(res)
}).catch((function (err) {
console.log(err)
_this.isToast = true
_this.toastMsg = "提交失败"
_this.toastType = "warn"
}))
}, 3000),
close () {
Bus.$emit("close-modal",false)
},
toastHide () {
if (this.toastType !== "text") {
this.name = ''
this.phone = ''
this.location = ''
this.materialDes = ''
}
},
}
}



// WEBPACK FOOTER //
// ./src/components/AddSubmit.vue